<template>
<section class="company-section _edit-section">
    <div class="section-inner">
        <div class="company-section-inner">
            <form v-on:submit.prevent="saveCompanyInfo">
            <!--Detail-->
            <div class="company-section-inner-item">
                <h2 class="heading_component"><span>Company Info</span></h2>

                <div class="company-item-wrap">

                    <div class="group">
                        <!--Contact-->
                        <div class="company-contact">

                            <div class="item form_text">
                                <div class="input-row">
                                    <input type="text" maxlength="250" id="edit-company-name" placeholder=" " v-model="company_info.name">
                                </div>
                                <label for="edit-company-name" maxlength="250" class="m-label"><span>会社名</span></label>
                            </div>
                            <div class="item form_text">
                                <div class="input-row">
                                    <input type="text" id="edit-company-phonetic" placeholder=" " v-model="company_info.phonetic">
                                </div>
                                <label for="edit-company-phonetic" class="m-label"><span>会社名フリガナ</span></label>
                            </div>
                            <div class="item form_text">
                                <div class="input-row">
                                    <input type="text" pattern="\d{3}-?\d{4}" maxlength="250" id="edit-post-code" placeholder=" " v-model="company_info.post_code">
                                </div>
                                <label for="edit-post-code" class="m-label"><span>郵便番号</span></label>
                            </div>
                            <div class="item form_text">
                                <div class="input-row">
                                    <input type="text" maxlength="250" id="edit-address" placeholder=" " v-model="company_info.address">
                                </div>
                                <label for="edit-address" class="m-label"><span>住所</span></label>
                            </div>
                            <div class="item form_text">
                                <div class="input-row">
                                    <input type="url" id="edit-map-url" placeholder=" " v-model="company_info.google_map_url">
                                </div>
                                <label for="edit-map-url" class="m-label"><span>GoogleMap URL</span></label>
                            </div>
                            <div class="item form_text">
                                <div class="input-row">
                                    <input type="tel" pattern="^(0{1}\d{9,10})$" id="edit-map-url" placeholder=" " v-model="company_info.tel">
                                </div>
                                <label for="edit-map-url" class="m-label"><span>電話番号</span></label>
                            </div>
                            <!-- <div class="item form_text">
                                <div class="input-row">
                                    <input type="url" id="edit-facebook-url" placeholder=" " v-model="company_info.facebook">
                                </div>
                                <label for="edit-facebook-url" class="m-label"><span>Facebook Account</span></label>
                            </div>
                            <div class="item form_text">
                                <div class="input-row">
                                    <input type="url" id="edit-twitter-url" placeholder=" " v-model="company_info.twitter">
                                </div>
                                <label for="edit-twitter-url" class="m-label"><span>Twitter Account</span></label>
                            </div>
                            <div class="item form_text">
                                <div class="input-row">
                                    <input type="url" id="edit-instagram-url" placeholder=" " v-model="company_info.instagram">
                                </div>
                                <label for="edit-instagram-url" class="m-label"><span>Instagram Account</span></label>
                            </div>
                            <div class="item form_text">
                                <div class="input-row">
                                    <input type="url" id="edit-line-url" placeholder=" " v-model="company_info.line">
                                </div>
                                <label for="edit-line-url" class="m-label"><span>Line Account</span></label>
                            </div> -->

                        </div>
                    </div>

                    <div class="company-detail">
                        <div class="item form_textarea">
                            <textarea maxlength="250" name="edit-concept" id="edit-concept1" v-model="company_info.description" placeholder="会社の説明文を入力してください"></textarea>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn_link-wrap">

                <!--LinkBtn - 決定アイコン -->
                <Button class="btn_link md_icon-text _white">
                    <div class="inner">
                        <span><div class="icon"><SvgIconCheck /></div>保存</span>
                    </div>
                </Button>

            </div><!--/.btn-link-wrap-->
        </form>
        </div><!--/.company-section-inner-->
    </div><!--/.section-inner-->
</section>
</template>

<script>
    import { Inertia } from '@inertiajs/inertia'
    import { reactive } from 'vue'

    import SvgIconClipBoard from '@/components/EndUser/svg/SvgIconClipBoard'
    import SvgIconSnsFacebook from '@/components/EndUser/svg/SvgIconSnsFacebook'
    import SvgIconSnsTwitter from '@/components/EndUser/svg/SvgIconSnsTwitter'
    import SvgIconSnsInstagram from '@/components/EndUser/svg/SvgIconSnsInstagram'
    import SvgIconSnsLine from '@/components/EndUser/svg/SvgIconSnsLine'
    import SvgIconMail from '@/components/EndUser/svg/SvgIconMail'
    import SvgIconChat from '@/components/EndUser/svg/SvgIconChat'
    import SvgIconAtmark from '@/components/EndUser/svg/SvgIconAtmark'
    import SvgIconPhone from '@/components/EndUser/svg/SvgIconPhone'
    import SvgIconCheck from '@/components/EndUser/svg/SvgIconCheck'

    export default {
        components: {
            SvgIconClipBoard,
            SvgIconSnsFacebook,
            SvgIconSnsTwitter,
            SvgIconSnsInstagram,
            SvgIconSnsLine,
            SvgIconMail,
            SvgIconChat,
            SvgIconAtmark,
            SvgIconPhone,
            SvgIconCheck,
        },
        props: {
            company: Object,
            pageType: Number
        },
        emits: ['openAlertModal'],
        data() {
            return {
                company_info: {}
            }
        },
        mounted() {
            this.company_info =  Object.assign({}, this.company);
        },
        methods: {
            saveCompanyInfo(){
                let routeName;
                if (this.pageType == 1) {
                    routeName = 'admin.shop.edit.company';
                } else if (this.pageType == 2) {
                    routeName = 'admin.brand.edit.company';
                } else if (this.pageType == 3) {
                    routeName = 'admin.showroom.edit.company';
                } 
                
                const form = reactive({
                    company_info: this.company_info
                })
                Inertia.post(route(routeName), form, {
                    onError: (errors) => {
                        this.$emit('openAlertModal', "error", errors); // 確認済み
                    },
                    onSuccess: visit => {
                        this.$emit('openAlertModal', "success", '保存しました', '会社情報を保存しました。'); // 確認済み
                    }
                })
            }
        }
    }
</script>